export default function normalizeFilterValues(filterValue) {
  if (Array.isArray(filterValue)) {
    return filterValue;
  }

  if (
    filterValue !== null &&
    filterValue !== undefined &&
    typeof filterValue !== "object"
  ) {
    return [filterValue];
  }

  return [];
}
